import confetti from "canvas-confetti";

let rafId = null;

export function celebrate() {
  const colors = ["#3B82F6", "#EF4444", "#22C55E", "#A855F7", "#F59E0B", "#EC4899"];
  const end = Date.now() + 1200;

  const frame = () => {
    confetti({ particleCount: 5, angle: 60, spread: 60, origin: { x: 0 }, colors });
    confetti({ particleCount: 5, angle: 120, spread: 60, origin: { x: 1 }, colors });
    if (Date.now() < end) {
      rafId = requestAnimationFrame(frame);
    } else {
      rafId = null;
    }
  };
  frame();

  confetti({
    particleCount: 120,
    spread: 90,
    startVelocity: 45,
    origin: { y: 0.6 },
    colors,
  });
}

export function stopConfetti() {
  if (rafId) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
  confetti.reset();
}
